import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import SydButton from '../../../../../../commonDesign/Button'
import Icon from '../../../../../../atoms/Icon'

const useStyles = makeStyles(() => ({
  root: {
    border: '1px solid var(--color-warning-300)',
    background: 'linear-gradient(135deg, var(--color-warning-050) 0%, white 100%)',
    borderRadius: 'var(--border-radius-lg)',
    padding: '14px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px'
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    color: 'var(--color-warning-700)'
  },
  summary: {
    fontSize: '13px',
    color: 'var(--color-neutral-700)',
    lineHeight: 1.5
  },
  feedbackInput: {
    width: '100%',
    border: '1px solid var(--color-neutral-300)',
    borderRadius: '6px',
    padding: '8px 10px',
    fontSize: '12px',
    fontFamily: 'inherit',
    resize: 'none',
    '&:focus': {
      outline: 'none',
      borderColor: 'var(--color-warning-400)'
    }
  },
  divider: {
    height: '1px',
    background: 'var(--color-warning-200)'
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  sectionLabel: {
    fontSize: '10px',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    color: 'var(--color-neutral-400)',
    marginBottom: '4px'
  },
  variablesBox: {
    margin: 0,
    fontSize: '11px',
    color: 'var(--color-neutral-600)',
    fontFamily: 'var(--font-mono, monospace)',
    backgroundColor: 'var(--color-neutral-050)',
    borderRadius: '4px',
    padding: '8px 10px',
    maxHeight: '100px',
    overflow: 'auto',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    lineHeight: 1.5
  }
}))

function ApprovalCard ({ interrupt, onApprove, onReject, isProcessing }) {
  const classes = useStyles()
  const [feedback, setFeedback] = useState('')

  const { description, variables } = interrupt || {}

  return (
    <div className={classes.root}>
      <div className={classes.titleRow}>
        <Icon name='warning' customSize='20px' />
        <span className='font-size-sm font-weight-semibold'>Approval Required</span>
      </div>

      {description && (
        <div className={classes.summary}>{description}</div>
      )}

      {variables && Object.keys(variables).length > 0 && (
        <div>
          <div className={classes.sectionLabel}>Variables</div>
          <pre className={classes.variablesBox}>
            {JSON.stringify(variables, null, 2)}
          </pre>
        </div>
      )}

      <textarea
        className={classes.feedbackInput}
        value={feedback}
        onChange={(e) => setFeedback(e.target.value)}
        placeholder='Optional feedback...'
        rows={2}
        disabled={isProcessing}
        aria-label='Approval feedback'
      />

      <div className={classes.divider} />

      <div className={classes.actions}>
        <SydButton
          size='sm'
          variant='outline'
          onClick={() => onReject(feedback)}
          disabled={isProcessing}
        >
          Reject
        </SydButton>
        <SydButton
          size='sm'
          variant='primary'
          onClick={() => onApprove(feedback)}
          disabled={isProcessing}
          processing={isProcessing}
        >
          Approve Execution
        </SydButton>
      </div>
    </div>
  )
}

ApprovalCard.propTypes = {
  interrupt: PropTypes.shape({
    description: PropTypes.string,
    variables: PropTypes.object
  }),
  onApprove: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired,
  isProcessing: PropTypes.bool
}

export default ApprovalCard
